import nl from './nl';

const data = {
  nl: nl,
};

export default data;
